import { Actions, Mutations } from '@/util/settings/enums';
import config from '@/config';
import fetchWithToken from '@/store/auth/authHelpers';
const actions = {
    async [Actions.SEND_FORM_DATA]({ commit, state }) {
        try {
            commit(Mutations.SET_FORM_API_LOADING, true);
            const response = await fetchWithToken(`${config.url.api.gmcConnectApi}/account/create`, 'POST', state);
            if (!response.ok) {
                const error = {
                    isError: true,
                    statusCode: response.status
                };
                commit(Mutations.SET_FORM_API_ERROR, error);
            }
            else {
                const cookieResponse = await fetchWithToken(`${config.url.api.gmcConnectApi}/cookie`);
                if (!cookieResponse.ok) {
                    commit(Mutations.SET_FORM_API_LOADING, false);
                    const cookieError = {
                        isError: true,
                        statusCode: cookieResponse.status
                    };
                    commit(Mutations.SET_FORM_API_ERROR, cookieError);
                    return cookieResponse;
                }
            }
            commit(Mutations.SET_FORM_API_LOADING, false);
            return response;
        }
        catch (err) {
            commit(Mutations.SET_FORM_API_LOADING, false);
            const error = {
                isError: true,
                statusCode: 500
            };
            commit(Mutations.SET_FORM_API_ERROR, error);
            throw err;
        }
    }
};
export default actions;
